import { render, staticRenderFns } from "./GuideChannelsFilter.vue?vue&type=template&id=46510947&scoped=true&"
import script from "./GuideChannelsFilter.vue?vue&type=script&lang=js&"
export * from "./GuideChannelsFilter.vue?vue&type=script&lang=js&"
import style0 from "./GuideChannelsFilter.vue?vue&type=style&index=0&id=46510947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46510947",
  null
  
)

export default component.exports